var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c("header-tabs", { attrs: { active: _vm.$route.path } }),
      _vm._v(" "),
      _c("el-row", { staticClass: "filter" }, [
        _c(
          "div",
          {
            staticStyle: {
              width: "80%",
              margin: "0 auto",
              "margin-top": "20px",
              "margin-bottom": "20px"
            }
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "demo-ruleForm",
                attrs: { model: _vm.form, "label-width": "180px" }
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "是否开启质检波次：" } },
                  [
                    _c("el-switch", {
                      attrs: { "active-value": 1, "inactive-value": 0 },
                      model: {
                        value: _vm.form.open_quality_wave,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "open_quality_wave", $$v)
                        },
                        expression: "form.open_quality_wave"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [_vm._v("质检拣货任务")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "任务最大数量：" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "50%" },
                      attrs: {
                        placeholder: "请输入最大拣货任务商品数量",
                        type: "number"
                      },
                      model: {
                        value: _vm.form.max_quality_task_goods_num,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "max_quality_task_goods_num", $$v)
                        },
                        expression: "form.max_quality_task_goods_num"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [_vm._v("质检汇总设置")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "有备注汇总波次上限:" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "50%" },
                      attrs: {
                        placeholder: "请输入最大波次数量",
                        type: "number"
                      },
                      model: {
                        value: _vm.form.max_quality_yes_remark_wave_summary_num,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "max_quality_yes_remark_wave_summary_num",
                            $$v
                          )
                        },
                        expression:
                          "form.max_quality_yes_remark_wave_summary_num"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "无备注汇总波次上限：" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "50%" },
                      attrs: {
                        placeholder: "请输入最大波次数量",
                        type: "number"
                      },
                      model: {
                        value: _vm.form.max_quality_no_remark_wave_summary_num,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "max_quality_no_remark_wave_summary_num",
                            $$v
                          )
                        },
                        expression:
                          "form.max_quality_no_remark_wave_summary_num"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [_vm._v("改标拣货任务")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "任务最大数量：" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "50%" },
                      attrs: {
                        placeholder: "请输入最大拣货任务商品数量",
                        type: "number"
                      },
                      model: {
                        value: _vm.form.max_label_task_goods_num,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "max_label_task_goods_num", $$v)
                        },
                        expression: "form.max_label_task_goods_num"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "波次数量上限：" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "50%" },
                      attrs: {
                        placeholder: "请输入最大波次数量",
                        type: "number"
                      },
                      model: {
                        value: _vm.form.max_label_task_wave_limit_num,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "max_label_task_wave_limit_num",
                            $$v
                          )
                        },
                        expression: "form.max_label_task_wave_limit_num"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否单汇总生成拣货任务：" } },
                  [
                    _c("el-switch", {
                      attrs: { "active-value": 1, "inactive-value": 0 },
                      model: {
                        value: _vm.form.is_only_summary_picking,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "is_only_summary_picking", $$v)
                        },
                        expression: "form.is_only_summary_picking"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [_vm._v("改标汇总设置")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "汇总人数上限：" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "50%" },
                      attrs: {
                        placeholder: "请输入最大汇总用户数量",
                        type: "number"
                      },
                      model: {
                        value: _vm.form.max_label_group_num,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "max_label_group_num", $$v)
                        },
                        expression: "form.max_label_group_num"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [_vm._v("PC质检提示")]),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "PC质检提示：" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "50%" },
                      attrs: { placeholder: "200字以内", type: "textarea" },
                      model: {
                        value: _vm.form.quality_text,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "quality_text", $$v)
                        },
                        expression: "form.quality_text"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "提示时间: " } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "120px" },
                      attrs: { type: "number", min: "0" },
                      model: {
                        value: _vm.form.quality_text_time,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "quality_text_time", _vm._n($$v))
                        },
                        expression: "form.quality_text_time"
                      }
                    }),
                    _vm._v("\n          秒\n        ")
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "is_height_goods_safety_clasp",
                      "label-width": "78px"
                    }
                  },
                  [
                    _vm._v("\n          当商品采购价>=\n          "),
                    _c("YsInput", {
                      staticStyle: { width: "100px" },
                      attrs: { pattern: "digit", min: "0" },
                      model: {
                        value: _vm.form.high_value_price,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "high_value_price", _vm._n($$v))
                        },
                        expression: "form.high_value_price"
                      }
                    }),
                    _vm._v(
                      "\n          ，记录为高单价商品并提醒商品绑定安全扣\n\n          "
                    ),
                    _c("el-switch", {
                      attrs: { "active-value": 1, "inactive-value": 2 },
                      model: {
                        value: _vm.form.is_height_goods_safety_clasp,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.form,
                            "is_height_goods_safety_clasp",
                            $$v
                          )
                        },
                        expression: "form.is_height_goods_safety_clasp"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { margin: "0px 10px" },
                        attrs: { type: "success", size: "small" },
                        on: { click: _vm.handleExportHighPrice }
                      },
                      [_vm._v("\n            导出高单价商品数据\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-upload",
                      {
                        staticStyle: { display: "inline-block" },
                        attrs: {
                          action: _vm.actionUrl,
                          name: "excel",
                          "on-success": _vm.highPriceImportSuccess,
                          "on-error": _vm.highPriceImportError,
                          "show-file-list": false,
                          "with-credentials": ""
                        }
                      },
                      [
                        _c(
                          "el-button",
                          { attrs: { size: "small", type: "primary" } },
                          [
                            _vm._v(
                              "\n              导入高单价商品数据\n            "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.onSubmit }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("el-row")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29095a51", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29095a51","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/adminsetting/QualityLabelSetting.vue
// module id = null
// module chunks = 